module.exports = __webpack_public_path__ + "img/pn.474778d0.svg";